import {
  ApiUserResponse,
  DeviceResponse,
  DeviceTypeCertificateResponse,
  DeviceTypeResponse,
  DeviceTypeSettingsResponse,
  FirmwareResponse,
  GlobalSettingsResponse,
  ProvisioningDeviceResponse,
  ReportForDeviceResponse,
  ReportForFirmwareGroupsResponse,
  StbGroupResponse,
  UpgradeRuleResponse,
  UserResponse,
  VersionResponse,
  BadRequestErrorResponse,
  InternalServerErrorResponse,
  ConflictErrorResponse,
  JobResponse,
  ReportForDeviceConnectionCountersResponse,
  ReportForDeviceCounterResponse,
  ReportForDevicesByWeekResponse,
  ReportForDeviceCountersResponse,
  ReportForStbGroupsResponse,
  ReportForStbGroupsResponseElements,
  ReportForIncorrectRequestsSummaryResponse,
  NewResourceResponse,
  ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries,
  ReportForFirmwareGroupsEntryByStbGroupResponse,
  ReportForDeviceResponseStbGroupHistoryElements,
  FirmwareType,
  RescueResponse,
  DeviceTypesResponse,
  FirmwareForRescueResponse,
  TagsResponse,
  FirmwareVersionsResponse,
  DeviceTypeRelationEntitiesResponse,
  StbGroupsResponse,
} from '@openapi';

export class ApiError {
  public error: BadRequestErrorResponse & InternalServerErrorResponse & ConflictErrorResponse;
  public code: number;

  constructor(error: BadRequestErrorResponse & InternalServerErrorResponse & ConflictErrorResponse, code: number) {
    this.error = error;
    this.code = code;
  }
}

export type Versions = VersionResponse;

export type DeviceTypeSettings = DeviceTypeSettingsResponse;

export interface GlobalSettings
  extends Omit<Omit<GlobalSettingsResponse, 'jobExportBatchWaitDuration'>, 'jobBatchWaitDuration'> {
  jobExportBatchWaitDuration: number;
  jobBatchWaitDuration: number;
}

export type ArrayWithPagination<T> = {
  searchString: string;
  from: number;
  to: number;
  showSizeChanger: true;
  total: number;
  items: Array<T>;
};

export interface Token {
  token: string; // base64 encoded User
  expiredAt: string;
}

export type User = { [key in keyof UserResponse]: NonNullable<UserResponse[key]> };

export type ApiUser = { [key in keyof ApiUserResponse]: NonNullable<ApiUserResponse[key]> };

export interface SuperGroup {
  id: string;
  name: string | null;
}

export type DeviceType = DeviceTypeResponse;

export interface AdministrationAction {
  id: string;
  creationDate: string;
  user: string;
  action: string;
  element: string;
  status: 'SUCCESS' | 'ERROR';
  moreInformation: string;
}

export type Job = { [key in keyof JobResponse]: NonNullable<JobResponse[key]> };

export type Firmware = FirmwareResponse;

export type JobExportDevices = NewResourceResponse;

export interface Version {
  FW?: {
    id: string;
    version: string;
  }[];
  UI?: {
    id: string;
    version: string;
  }[];
  LOADER?: {
    id: string;
    version: string;
  }[];
  CUSTOFW1?: {
    id: string;
    version: string;
  }[];
  CUSTOFW2?: {
    id: string;
    version: string;
  }[];
  CUSTOFW3?: {
    id: string;
    version: string;
  }[];
  version?: 'UI' | 'FW' | 'LOADER';
}

export interface FirmwareSummary {
  etc: {
    descriptionFile?: {
      fileVersion: string | null;
      name: string | null;
      version: string | null;
      type: string | null;
      date: string | null;
      hardwareId: string | null;
      usageId: string | null;
      client: string | null;
      comment: string | null;
      sha256: string | null;
    };
  };
}

export type DeviceFilterVersions = {
  loaderVersions: string[];
  fwVersions: string[];
  uiVersions: string[];
  customFw1Versions: string[];
  customFw2Versions: string[];
  customFw3Versions: string[];
};

export type Rule = UpgradeRuleResponse;

export type Rescues = RescueResponse;

export type RescuesDevice = DeviceTypesResponse;

export type RescuesFirmwareDevice = FirmwareForRescueResponse;

export type GroupMapList = ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries;

export type GroupMapListVersion = ReportForFirmwareGroupsEntryByStbGroupResponse;

export type DeviceConnectChart = ReportForDeviceConnectionCountersResponse;

export type DeviceNumberChart = ReportForDevicesByWeekResponse;

export type Device = DeviceResponse;

export type DeviceTotal = ReportForDeviceCountersResponse;

export type DeviceTotalChart = ReportForDeviceCounterResponse;

export type StbTotal = ReportForStbGroupsResponse;

export type StbTotalChart = ReportForStbGroupsResponseElements;

export type StbChart = StbGroupsResponse;

export type IncorrectSummary = ReportForIncorrectRequestsSummaryResponse;

export type ReportForDevice = ReportForDeviceResponse;

export type FirmwareReportGroup = ReportForFirmwareGroupsResponse;

export type TagsPage = TagsResponse;

export type UnusedFirmwares = FirmwareResponse;

export type FirmwareFilterVersions = FirmwareVersionsResponse;

export type DeviceTypeRelation = DeviceTypeRelationEntitiesResponse;

export interface RulesWithDeviceType extends UpgradeRuleResponse {
  deviceTypeName?: DeviceType['deviceName'];
  superGroupName?: SuperGroup['name'];
  stbGroup?: StbGroup[];
}

export type StbGroup = StbGroupResponse;

export interface StbGroupExtended extends StbGroupResponse {
  deviceTypeName?: DeviceType['deviceName'];
  superGroupName?: SuperGroup['name'];
}

export type DeviceTypeCertificates = DeviceTypeCertificateResponse;

export interface DeviceCertificates extends DeviceTypeCertificateResponse {
  deviceTypeName?: DeviceType['deviceName'];
}

export type ProvisionedDevice = ProvisioningDeviceResponse;

export interface ProvisionedDeviceExtended extends ProvisioningDeviceResponse {
  deviceTypeName?: DeviceType['deviceName'];
  stbGroupName?: StbGroup['name'];
}
export interface StbHistoryType extends ReportForDeviceResponseStbGroupHistoryElements {
  quotaFirmwareType: FirmwareType;
}
